/* Italian Charms – Nouvelle page produit · assets/ic-pdp.js (defer) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function gallery(root) {
    var track = root.querySelector('[data-gal-track]');
    if (!track) return null;
    var slides = $$(track, '[data-gal-slide]');
    var thumbs = $$(root, '[data-gal-thumb]');
    var prev = root.querySelector('[data-gal-prev]'), next = root.querySelector('[data-gal-next]');
    function idx() { return Math.round(track.scrollLeft / track.clientWidth) || 0; }
    function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
    function sync() {
      var i = idx();
      thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
    if (next) next.addEventListener('click', function () { go(idx() + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx() - 1); }
    });
    sync();
    return {
      toMedia: function (mediaId) {
        slides.forEach(function (s, k) { if (String(s.getAttribute('data-media-id')) === String(mediaId)) go(k); });
      }
    };
  }

  function deliveryDates(root) {
    $$(root, '[data-deliv]').forEach(function (el) {
      var days = (el.getAttribute('data-days') || '').split(',').map(function (s) { return s.trim(); });
      var months = (el.getAttribute('data-months') || '').split(',').map(function (s) { return s.trim(); });
      var min = parseInt(el.getAttribute('data-min'), 10) || 2, max = parseInt(el.getAttribute('data-max'), 10) || 4;
      function add(n) { var d = new Date(), a = 0; while (a < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) a++; } return d; }
      function fmt(d) { return (days[d.getDay()] || '') + ' ' + d.getDate() + ' ' + (months[d.getMonth()] || ''); }
      var a = el.querySelector('[data-deliv-min]'), b = el.querySelector('[data-deliv-max]');
      if (a) a.textContent = fmt(add(min));
      if (b) b.textContent = fmt(add(max));
    });
  }

  function stories(root) {
    var dlg = root.querySelector('[data-story-dialog]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var holder = dlg.querySelector('[data-story-holder]');
    $$(root, '[data-story]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tpl = btn.querySelector('template');
        if (!tpl) return;
        holder.innerHTML = '';
        holder.appendChild(tpl.content.cloneNode(true));
        dlg.showModal();
        var v = holder.querySelector('video');
        if (v) { v.muted = false; v.play().catch(function () { v.muted = true; v.play().catch(function () {}); }); }
      });
    });
    function close() { var v = holder.querySelector('video'); if (v) v.pause(); holder.innerHTML = ''; if (dlg.open) dlg.close(); }
    dlg.querySelector('[data-story-close]').addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('close', function () { var v = holder.querySelector('video'); if (v) v.pause(); holder.innerHTML = ''; });
  }

  function pdp(root) {
    var dataEl = root.querySelector('[data-icp-product]');
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var gal = gallery(root);
    deliveryDates(root);
    stories(root);

    var form = root.querySelector('form.icp-form-el');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var buyBtn = root.querySelector('[data-buy]');
    var buyLabel = root.querySelector('[data-buy-label]');
    var buyTotal = root.querySelector('[data-buy-total]');
    var msg = root.querySelector('[data-buy-msg]');
    var buyWrap = root.querySelector('[data-buy-wrap]');
    var extrasWrap = root.querySelector('[data-extras]');
    var toolBtn = root.querySelector('[data-tool]');
    var giftBtn = root.querySelector('[data-gift]');
    /* Coffrets automatiques (pages charms) : plusieurs articles, outil non inclus */
    var autoBox = !!root.querySelector('.icp-box--auto');

    var state = {
      mode: 'solo',
      variant: product ? (product.variants.filter(function (v) { return String(v.id) === (idInput ? idInput.value : ''); })[0] || product.variants[0]) : null,
      box: null
    };
    var formsWrap = root.querySelector('[data-forms]');
    if (formsWrap) state.mode = formsWrap.getAttribute('data-default') || 'solo';
    /* Coffrets épuisés : masqués, prix « dès » recalculé sur les coffrets disponibles */
    var okBoxes = $$(root, '[data-box]').filter(function (b) { if (b.disabled) b.hidden = true; return !b.disabled; });
    var boxForm = root.querySelector('[data-form="box"]');
    if (boxForm) {
      if (!okBoxes.length) {
        boxForm.remove();
        var bp = root.querySelector('[data-panel="box"]'); if (bp) bp.remove();
      } else {
        var minP = Math.min.apply(null, okBoxes.map(function (b) { return parseInt(b.getAttribute('data-price'), 10) || 0; }));
        var pe = boxForm.querySelector('[data-box-price]');
        if (pe) {
          var first = pe.textContent.trim().split(' ')[0];
          var from = /\d/.test(first) ? '' : first + ' ';
          pe.textContent = (okBoxes.length > 1 ? from : '') + money(minP);
          var sEl = pe.nextElementSibling; if (sEl && sEl.tagName === 'S') sEl.remove();
        }
      }
    }
    if (!root.querySelector('[data-form="' + state.mode + '"]')) state.mode = 'solo';

    function basePrice() {
      if (state.mode === 'box') return state.box ? state.box.price : 0;
      return state.variant ? state.variant.price : 0;
    }
    function total() {
      var t = basePrice();
      if (toolBtn && (state.mode === 'solo' || autoBox) && toolBtn.getAttribute('aria-pressed') === 'true') t += parseInt(toolBtn.getAttribute('data-price'), 10) || 0;
      return t;
    }
    /* Bloc « Dans la boîte » : on montre la ligne de la variante choisie */
    var contents = root.querySelector('[data-contents]');
    function syncContents() {
      if (!contents || !state.variant) return;
      var opts = state.variant.options || [];
      var rows = $$(contents, '[data-for]');
      var any = rows.some(function (r) { var f = r.getAttribute('data-for'); return f && opts.indexOf(f) > -1; });
      rows.forEach(function (r) {
        var f = r.getAttribute('data-for');
        r.hidden = any ? !(f && opts.indexOf(f) > -1) : !!f;
      });
    }
    function refresh() {
      syncContents();
      if (state.variant) {
        $$(root, '[data-icp-price]').forEach(function (el) { el.textContent = money(state.variant.price); });
        $$(root, '[data-icp-compare]').forEach(function (el) {
          var c = state.variant.compare_at_price;
          el.textContent = c && c > state.variant.price ? money(c) : '';
        });
      }
      if (state.variant) {
        $$(root, '[data-instock]').forEach(function (el) { el.hidden = !state.variant.available; });
      }
      if (buyTotal) {
        buyTotal.textContent = (state.mode === 'box' && !state.box) ? '' : money(total());
      }
      if (buyBtn) {
        var soldOut = state.mode === 'solo' && state.variant && !state.variant.available;
        buyBtn.disabled = !!soldOut;
        if (buyLabel) buyLabel.textContent = soldOut ? buyBtn.getAttribute('data-soldout') : buyBtn.getAttribute('data-label');
        if (buyTotal) {
          buyTotal.hidden = !!soldOut || !buyTotal.textContent;
        }
      }
    }

    /* ---- Options / variantes ---- */
    $$(root, '[data-opt]').forEach(function (group) {
      var label = group.querySelector('[data-opt-value]');
      $$(group, '[data-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          $$(group, '[data-value]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
          if (label) label.textContent = btn.getAttribute('data-value');
          if (!product) return;
          var chosen = [];
          $$(root, '[data-opt]').forEach(function (g) {
            var on = g.querySelector('[data-value][aria-pressed="true"]');
            chosen[parseInt(g.getAttribute('data-opt'), 10)] = on ? on.getAttribute('data-value') : null;
          });
          var match = product.variants.filter(function (v) {
            return v.options.every(function (o, i) { return chosen[i] == null || chosen[i] === o; });
          })[0];
          if (match) {
            state.variant = match;
            if (idInput) idInput.value = match.id;
            if (match.featured_media && gal) gal.toMedia(match.featured_media.id);
            try { var u = new URL(location.href); u.searchParams.set('variant', match.id); history.replaceState(null, '', u); } catch (e) {}
          }
          refresh();
        });
      });
    });

    /* ---- Formules ---- */
    function applyTool() {
      if (!toolBtn) return;
      var price = toolBtn.querySelector('[data-tool-price]');
      if (state.mode === 'box' && !autoBox) {
        toolBtn.setAttribute('aria-pressed', 'true');
        toolBtn.classList.add('is-locked');
        toolBtn.setAttribute('aria-disabled', 'true');
        if (price) price.textContent = toolBtn.getAttribute('data-free');
      } else {
        if (toolBtn.classList.contains('is-locked')) toolBtn.setAttribute('aria-pressed', 'false');
        toolBtn.classList.remove('is-locked');
        toolBtn.removeAttribute('aria-disabled');
        if (price) price.textContent = money(parseInt(toolBtn.getAttribute('data-price'), 10) || 0);
      }
    }
    function setMode(mode) {
      state.mode = mode;
      $$(root, '[data-form]').forEach(function (f) { f.setAttribute('aria-pressed', String(f.getAttribute('data-form') === mode)); });
      $$(root, '[data-panel]').forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-panel') === mode); });
      var builder = mode === 'builder';
      if (buyWrap) buyWrap.hidden = builder;
      if (extrasWrap) extrasWrap.hidden = builder;
      if (msg) msg.textContent = '';
      applyTool();
      refresh();
    }
    $$(root, '[data-form]').forEach(function (f) { f.addEventListener('click', function () { setMode(f.getAttribute('data-form')); }); });
    var pick = root.querySelector('[data-box-pick]');
    var boxPrice = root.querySelector('[data-box-price]');
    $$(root, '[data-box]').forEach(function (b) {
      b.addEventListener('click', function () {
        $$(root, '[data-box]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        state.box = { id: b.getAttribute('data-box'), price: parseInt(b.getAttribute('data-price'), 10) || 0, title: b.getAttribute('data-title') };
        if (pick) pick.textContent = state.box.title;
        if (boxPrice) boxPrice.textContent = money(state.box.price);
        if (msg) msg.textContent = '';
        refresh();
      });
    });

    /* ---- Outil / cadeau ---- */
    [toolBtn, giftBtn].forEach(function (b) {
      if (!b) return;
      b.addEventListener('click', function () {
        if (b.classList.contains('is-locked')) return;
        b.setAttribute('aria-pressed', String(b.getAttribute('aria-pressed') !== 'true'));
        refresh();
      });
    });

    /* ---- Carte cadeau : envoi à un proche ---- */
    var rcp = root.querySelector('[data-rcp]');
    if (rcp) {
      var rcpOn = rcp.querySelector('[data-rcp-on]'), rcpFields = rcp.querySelector('[data-rcp-fields]');
      var rcpDate = rcp.querySelector('[data-rcp-date]'), rcpOff = rcp.querySelector('[data-rcp-offset]');
      var d0 = new Date(), d1 = new Date(); d1.setDate(d1.getDate() + 90);
      if (rcpDate) { rcpDate.min = d0.toISOString().slice(0, 10); rcpDate.max = d1.toISOString().slice(0, 10); }
      if (rcpOff) rcpOff.value = String(new Date().getTimezoneOffset());
      rcpOn.addEventListener('change', function () {
        rcpFields.hidden = !rcpOn.checked;
        $$(rcpFields, 'input, textarea').forEach(function (f) { f.disabled = !rcpOn.checked; });
      });
    }

    /* ---- Ajout au panier ---- */
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (msg) msg.textContent = '';
      var items = [];
      var props = {};
      if (rcp && rcp.querySelector('[data-rcp-on]').checked) {
        var em = rcp.querySelector('[data-rcp-email]');
        if (!em.value || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em.value)) {
          if (msg) msg.textContent = rcp.getAttribute('data-rcp-error');
          em.setAttribute('aria-invalid', 'true'); em.focus();
          return;
        }
        em.removeAttribute('aria-invalid');
        $$(form, '[name^="properties["]').forEach(function (f) {
          if (f.disabled || !f.value) return;
          if (f.type === 'checkbox' && !f.checked) return;
          props[f.name.slice(11, -1)] = f.value;
        });
      }
      if (giftBtn && giftBtn.getAttribute('aria-pressed') === 'true') props[giftBtn.getAttribute('data-prop') || 'Cadeau'] = giftBtn.getAttribute('data-value') || 'Oui';
      if (state.mode === 'box') {
        if (!state.box) {
          if (msg) msg.textContent = buyBtn.getAttribute('data-choose');
          var panel = root.querySelector('[data-panel="box"]');
          if (panel) panel.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
          return;
        }
        String(state.box.id).split(',').forEach(function (x) { if (x) items.push({ id: Number(x), quantity: 1, properties: props }); });
        if (autoBox && toolBtn && toolBtn.getAttribute('aria-pressed') === 'true' && toolBtn.getAttribute('data-variant')) {
          items.push({ id: Number(toolBtn.getAttribute('data-variant')), quantity: 1 });
        }
      } else {
        items.push({ id: Number(idInput.value), quantity: 1, properties: props });
        if (toolBtn && toolBtn.getAttribute('aria-pressed') === 'true' && toolBtn.getAttribute('data-variant')) {
          items.push({ id: Number(toolBtn.getAttribute('data-variant')), quantity: 1 });
        }
      }
      buyBtn.classList.add('is-loading');
      /* 02/11/2026 : le panier s'ouvre tout de suite (comme chez Paalm), puis se remplit */
      var mcOpt = document.getElementById('mini-cart');
      if (mcOpt && root.getAttribute('data-after-add') !== 'cart') { try { mcOpt.classList.add('icx-chargement'); mcOpt.open = true; } catch (e) {} }
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var payload = JSON.stringify({ items: items, sections: ['mini-cart'] });
      var send = function (retry) {
        return fetch(base + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: payload
        }).then(function (r) {
          if ((r.status === 429 || r.status >= 500) && retry) {
            return new Promise(function (ok) { setTimeout(ok, 1500); }).then(function () { return send(false); });
          }
          return r.text().then(function (t) { var j = null; try { j = JSON.parse(t); } catch (e) {} return { ok: r.ok, status: r.status, json: j }; });
        });
      };
      if (msg) msg.textContent = '';
      send(true)
        .then(function (res) {
          if (!res.ok || !res.json) {
            var d = res.json && (res.json.description || res.json.message);
            if (res.status === 422 && /variant/i.test(d || '')) d = buyBtn.getAttribute('data-unavailable') || 'Ce produit n\u2019est pas encore disponible \u00e0 la commande.';
            throw new Error(typeof d === 'string' && d ? d : (buyBtn.getAttribute('data-error') || 'Impossible d\u2019ajouter au panier. R\u00e9essaie dans un instant.'));
          }
          if (root.getAttribute('data-after-add') === 'cart') { location.href = base + 'cart'; return; }
          return fetch(base + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
            cart.sections = res.json.sections;
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, openMiniCart: true } }));
            root.dispatchEvent(new CustomEvent('variant:added', { bubbles: true, detail: { variant: res.json.items ? res.json.items[0] : res.json } }));
          });
        })
        .catch(function (err) { if (msg) msg.textContent = err.message; if (mcOpt) { try { mcOpt.open = false; } catch (e) {} } })
        .then(function () { buyBtn.classList.remove('is-loading'); if (mcOpt) setTimeout(function () { mcOpt.classList.remove('icx-chargement'); }, 400); });
    });

    setMode(state.mode);
  }

  function band(root) {
    if (reduce) return;
    var track = root.querySelector('[data-band-track]');
    if (!track) return;
    var unit = track.innerHTML, guard = 0;
    while (track.scrollWidth < root.clientWidth + 200 && guard < 30) {
      var tmp = document.createElement('div'); tmp.innerHTML = unit;
      Array.prototype.slice.call(tmp.children).forEach(function (el) { el.setAttribute('aria-hidden', 'true'); track.appendChild(el); });
      guard++;
    }
    var tmp2 = document.createElement('div'); tmp2.innerHTML = track.innerHTML;
    Array.prototype.slice.call(tmp2.children).forEach(function (el) { el.setAttribute('aria-hidden', 'true'); track.appendChild(el); });
    root.classList.add('is-animated');
  }

  function init(el) {
    if (el.dataset.icpReady) return;
    el.dataset.icpReady = '1';
    if (el.hasAttribute('data-icp')) pdp(el);
    if (el.hasAttribute('data-icp-band')) band(el);
  }
  function all() { document.querySelectorAll('[data-icp], [data-icp-band]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-icp], [data-icp-band]').forEach(init);
  });
})();
